import { render, staticRenderFns } from "./OrganismCards.vue?vue&type=template&id=2a0a7e00"
import script from "./OrganismCards.vue?vue&type=script&lang=js"
export * from "./OrganismCards.vue?vue&type=script&lang=js"
import style0 from "./OrganismCards.vue?vue&type=style&index=0&id=2a0a7e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports